import { safeLocalStorage } from '@fluidx/utilities';
import * as localStorageKeys from './localStorageKeys';

export function rerouteIframeToSourcelessIframe(): boolean {
  return !!safeLocalStorage()?.[localStorageKeys.fluidRerouteIframeToSourceless];
}
